import dayjs from 'dayjs';

export function isSameUtcDay(refreshTimeString: string): boolean {
  // Parse the refreshTime as a Date object
  const refreshDate = new Date(refreshTimeString);

  // Get the current date in UTC
  const currentDate = new Date();

  // Compare the year, month, and day
  return (
    refreshDate.getUTCFullYear() === currentDate.getUTCFullYear() &&
    refreshDate.getUTCMonth() === currentDate.getUTCMonth() &&
    refreshDate.getUTCDate() === currentDate.getUTCDate()
  );
}

export const checkPhotoValidity = (photoURL: string): Promise<boolean> => {
  return new Promise((resolve) => {
    const image = new Image();
    image.src = photoURL;
    image.onload = () => resolve(true);
    image.onerror = () => resolve(false);
  });
};

export const FIRST_DAY_OF_FLAGLE = dayjs('2022-02-21');

export function getPuzzleNumber(dayString: string): number {
  return Math.floor(dayjs(dayString).diff(FIRST_DAY_OF_FLAGLE, 'day'));
}

/**
 * A puzzle's date written out in the player's language.
 *
 * dayjs is used unlocalised throughout this app — none of its locale data is
 * imported — so `.format('D MMMM YYYY')` would say "August" to all eleven
 * languages. Intl already knows every one of them and costs no bundle weight.
 */
export function formatPuzzleDate(dayString: string, language: string): string {
  const date = dayjs(dayString).toDate();
  try {
    return new Intl.DateTimeFormat(language, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(date);
  } catch {
    // A malformed tag from the language detector throws RangeError; a merely
    // unsupported one (co, eu) does not — Intl falls back on its own.
    return dayjs(dayString).format('D MMMM YYYY');
  }
}

export const BANNED_COUNTRIES = ['IL', 'PS', 'RU'];
